// Use a render function to get around making a lot of wrapper components
// that only contain <router-view />
// https://github.com/vuejs/vue-router/issues/1507#issuecomment-345490711
export default function getRouterView() {
    return {
        render( createElement ) {
            return createElement( 'router-view' );
        },
    };
}

// Fallback browser tab title
export const DEFAULT_DOCUMENT_TITLE = 'Hickory';

/**
 * Read a meta field from the deepest matched route that declares it,
 * so a child route can override its parent and a child without the field inherits it.
 * @param { Array } matchedRoutes - a route's 'matched' array, ordered parent -> child
 * @param { String } field - name of the meta field to read
 * @returns { * } the field value, or undefined when no matched route declares it
 */
function getDeepestMeta( matchedRoutes, field ) {
    const routeWithField = [ ...matchedRoutes ]
        .reverse()
        .find( ( matchedRoute ) => matchedRoute.meta && matchedRoute.meta[ field ] );

    return routeWithField
        ? routeWithField.meta[ field ]
        : undefined;
}

/**
 * Resolve the browser tab title for a route.
 * A route declaring 'meta.detailParam' shows a detail sub page whenever that param is present,
 * and the ISBN of the record open in it is prepended to the title.
 * @param { Object } route - a resolved route, read for its 'matched' and 'params'
 * @param { String } [ isbn ] - ISBN of the record open in a detail sub page, when one is loaded
 * @returns { String }
 */
export function getDocumentTitle( route = {}, isbn = '' ) {
    const { matched = [], params = {} } = route;

    const baseTitle = getDeepestMeta( matched, 'documentTitle' ) || DEFAULT_DOCUMENT_TITLE;
    const detailParam = getDeepestMeta( matched, 'detailParam' );
    const isDetailSubPageOpen = !!detailParam && !!params[ detailParam ];

    return ( isDetailSubPageOpen && isbn )
        ? `${ isbn } | ${ baseTitle }`
        : baseTitle;
}
